export type Preview = {
  id: string;
  src: string;
  caption: string;
  tag: string;
};

export const previews: Preview[] = [
  {
    id: 'confronto',
    src: 'https://cdn.magicpatterns.com/uploads/fBtkxu7UAuMvqw5aEngVex/Screenshot_20260910_131548_Drive.jpg',
    caption: 'Hangeul vs. Alfabeto: perché il coreano è più facile di quanto pensi',
    tag: 'Tomo 1',
  },
  {
    id: 'flashcard-vocali',
    src: 'https://cdn.magicpatterns.com/uploads/cM4bFEJT2VBwETL5WxQnQh/Screenshot_20260910_132150_Drive.jpg',
    caption: 'Flashcard visive — Set 3: le vocali con associazioni immediate',
    tag: 'Tomo 1',
  },
  {
    id: 'pronuncia',
    src: 'https://cdn.magicpatterns.com/uploads/buykR7R3PSfmMPvuybzWg7/Screenshot_20260910_131601_Drive.jpg',
    caption: 'La scienza della pronuncia: dove nasce ogni suono coreano',
    tag: 'Tomo 2',
  },
  {
    id: 'flashcard-vocabolario',
    src: 'https://cdn.magicpatterns.com/uploads/uaXauB7qT2PcwPftpoPqcz/Screenshot_20260910_132212_Drive.jpg',
    caption: 'Flashcard visive — Set 4: il vocabolario di uso quotidiano',
    tag: 'Tomo 3',
  },
  {
    id: 'street-food',
    src: 'https://cdn.magicpatterns.com/uploads/fLsLfpXBpiLAfiVbthhapr/Screenshot_20260910_131629_Drive.jpg',
    caption: 'Street food & snack di Seoul, con pronuncia parola per parola',
    tag: 'Bonus K-Food',
  },
  {
    id: 'slang',
    src: 'https://cdn.magicpatterns.com/uploads/rbbaqem9C7B9on2P6kH6af/Screenshot_20260910_131710_Drive.jpg',
    caption: 'Slang di Internet coreano: scrivi ai tuoi idol come un fan locale',
    tag: 'Tomo 5',
  },
  {
    id: 'fan-chants',
    src: 'https://cdn.magicpatterns.com/uploads/pJ8bM5PBhNcA5yhFE3goSS/Screenshot_20260910_132035_Drive.jpg',
    caption: 'Interazione dal vivo & fan-chant, con lettura romanizzata',
    tag: 'Bonus IDOL',
  },
  {
    id: 'lettere',
    src: 'https://cdn.magicpatterns.com/uploads/coecxrGTQHVFbp2ctjKVc9/Screenshot_20260910_132108_Drive.jpg',
    caption: 'Anniversari & lettere d’amore: 100 frasi pronte da usare',
    tag: 'Bonus IDOL',
  },
];
